import React, { ReactNode, useEffect } from 'react';

type ModalProps = {
  isOpen: boolean;
  title?: ReactNode;
  children?: ReactNode;
  confirmText?: string;
  cancelText?: string;
  onConfirm?: () => void | Promise<void>;
  onClose?: () => void;
  loading?: boolean;
  disableBackdropClose?: boolean;
  hideActions?: boolean;
  /** Classe extra no container `.modal-content` (ex.: largura maior). */
  contentClassName?: string;
  /** Exibe botão X no cabeçalho (chama `onClose`). */
  showHeaderClose?: boolean;
};

export function Modal({
  isOpen,
  title,
  children,
  confirmText = 'Confirmar',
  cancelText = 'Cancelar',
  onConfirm,
  onClose,
  loading = false,
  disableBackdropClose = false,
  hideActions = false,
  contentClassName,
  showHeaderClose = false,
}: ModalProps) {
  useEffect(() => {
    const handleKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen && !disableBackdropClose) {
        onClose?.();
      }
    };
    if (isOpen) {
      document.addEventListener('keydown', handleKeyDown);
    }
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [isOpen, disableBackdropClose, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="bg-modal"
      onClick={() => {
        if (!disableBackdropClose) onClose?.();
      }}
    >
      <div
        className={contentClassName ? `modal-content ${contentClassName}` : 'modal-content'}
        onClick={(e) => e.stopPropagation()}
      >
        {title && (
          <div
            className={
              showHeaderClose
                ? 'modal-title modal-title-with-close'
                : 'modal-title'
            }
          >
            <span className="modal-title-text">{title}</span>
            {showHeaderClose && (
              <button
                type="button"
                className="modal-close-x"
                onClick={onClose}
                aria-label="Fechar"
              >
                ×
              </button>
            )}
          </div>
        )}

        {!loading && children && (
          <div className="modal-body">{children}</div>
        )}

        {loading && (
          <div className="modal-body" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: 80 }}>
            <span className="loadingText">Processando...</span>
          </div>
        )}

        {!hideActions && (
          <div className="modalActions">
            {!loading && (
              <>
                <button
                  className="modalButton"
                  onClick={onConfirm}
                >
                  {confirmText}
                </button>
                <button
                  className="modalButton"
                  onClick={onClose}
                >
                  {cancelText}
                </button>
              </>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default Modal;


